import React from "react";

interface IModalProps {}

export const LoginEsiaForm: React.FC<IModalProps> = () => {
  return (
    <div style={{ width: "500px", textAlign: "center" }}>
      Ваша учетная запись создана. Для продолжения работы Вам необходимо
      направить заполненную форму на адрес rsiek@sspk.spb.ru. После назначения
      роли на почту, указанную в учетной записи, будет направлено письмо о
      необходимости авторизоваться повторно.
    </div>
  );
};
